var React = require('react');

function SchoolInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"school_24px"},React.createElement("path",{"id":"icon/social/school_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M24.9999 6.25L2.08325 18.75L10.4166 23.2917V35.7917L24.9999 43.75L39.5832 35.7917V23.2917L43.7499 21.0208V35.4167H47.9166V18.75L24.9999 6.25ZM39.2082 18.75L24.9998 26.5L10.7915 18.75L24.9998 11L39.2082 18.75ZM24.9999 39L35.4166 33.3125V25.5625L24.9999 31.25L14.5833 25.5625V33.3125L24.9999 39Z","fill":"#FF5C5C"})));
}

SchoolInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = SchoolInline;

SchoolInline.default = SchoolInline;
